import { post, get, request } from "./http.js";
/**
 * 注册
 * @param {} data 
 * @returns 
 */
const userRegister = (data) => post("user/register", data);
/**
 * 登录
 * @param {} data 
 * @returns 
 */
const userLogin = (data) => post("user/login", data);
/**
 * 获取用户信息
 * @param {} data 
 * @returns 
 */
const userIndex = (data) => post("user/index", data);
/**
 * 退出登录
 * @param {} data 
 * @returns 
 */
const userLogout = (data) => post("user/logout", data);
/**
 * 重置密码
 * @param {} data 
 * @returns 
 */
const userResetpwd = (data) => post("user/resetpwd", data);
/**
 * 家长实名认证
 * @param {} data 
 * @returns 
 */
const userParentsauth = (data) => post("user/parentsauth", data);
/**
 * 学生信息认证
 * @param {} data 
 * @returns 
 */
const userStudentauth = (data) => post("user/studentauth", data);
/**
 * 练习题错题集列表
 * @param {} data 
 * @returns 
 */
const userTrainwrongloglist = (data) => post("user/trainwrongloglist", data);
/**
 * 考试错题集列表
 * @param {} data 
 * @returns 
 */
const userExamwrongloglist = (data) => post("user/examwrongloglist", data);
/**
 * 练习题错题集所有错题
 * @param {} data 
 * @returns 
 */
const userTrainwrongtimu = (data) => post("user/trainwrongtimu", data);
/**
 * 考试错题集所有错题
 * @param {} data 
 * @returns 
 */
const userExamwrongtimu = (data) => post("user/examwrongtimu", data);
/**
 * 考试错题集所有错题 新
 * @param {} data 
 * @returns 
 */
const userExamwrongtimunew = (data) => post("user/examwrongtimunew", data);
/**
 * 练习记录
 * @param {} data 
 * @returns 
 */
const userTrainlog = (data) => post("user/trainlog", data);
/**
 * 考试记录
 * @param {} data 
 * @returns 
 */
const userExamlog = (data) => post("user/examlog", data);
/**
 * 练习题错题集所有错题 新
 * @param {} data 
 * @returns 
 */
const userTrainwrongtimunew = (data) => post("user/trainwrongtimunew", data);

/**
 * 得到首页banner及简介数据
 * @param {} data 
 * @returns 
 */
const indexBaseinfo = (data) => post("index/baseinfo", data);
/**
 * 首页得到最新课程
 * @param {} data 
 * @returns 
 */
const indexNewcourse = (data) => post("index/newcourse", data);
/**
 * 首页得到各课程分类下的课程
 * @param {} data 
 * @returns 
 */
const indexCatecourse = (data) => post("index/catecourse", data);
/**
 * 得到底部配置信息
 * @param {} data 
 * @returns 
 */
const indexGetfooter = (data) => post("index/getfooter", data);
/**
 * 得到关于我们简介
 * @param {} data 
 * @returns 
 */
const indexAboutus = (data) => post("index/aboutus", data);
/**
 * 得到校园环境
 * @param {} data 
 * @returns 
 */
const indexEnvironment = (data) => post("index/environment", data);
/**
 * 得到学员风采
 * @param {} data 
 * @returns 
 */
const indexFengcai = (data) => post("index/fengcai", data);
//录播课
/**
 * 得到课程分类
 * @param {} data 
 * @returns 
 */
const courseGetcate = (data) => post("course/getcate", data);
/**
 * 得到课程列表
 * @param {} data 
 * @returns 
 */
const courseGetlist = (data) => post("course/getlist", data);
/**
 * 课程详情
 * @param {} data 
 * @returns 
 */
const courseCoursedetail = (data) => post("course/coursedetail", data);
/**
 * 记录学习日志
 * @param {} data 
 * @returns 
 */
const courseSetstudylog = (data) => post("course/setstudylog", data);

/**
 * 题库 得到一级分类
 * @param {} data 
 * @returns 
 */
const timuGetcate = (data) => post("timu/getcate", data);
/**
 * 题库 得到子级分类
 * @param {} data 
 * @returns 
 */
const timuGetchildcate = (data) => post("timu/getchildcate", data);
/**
 * 得到题库列表
 * @param {} data 
 * @returns 
 */
const timuGetlibrarylist = (data) => post("timu/getlibrarylist", data);
/**
 * 得到题库中的所有题目
 * @param {} data 
 * @returns 
 */
const timuGettimulist = (data) => post("timu/gettimulist", data);
/**
 * 新得到题库中的所有题目
 * @param {} data 
 * @returns 
 */
const timuGettimulistnew = (data) => post("timu/gettimulistnew", data);
/**
 * 记录刷题日志
 * @param {} data 
 * @returns 
 */
const timuSettrainlog = (data) => post("timu/settrainlog", data);
/**
 * 提交刷题记录
 * @param {} data 
 * @returns 
 */
const timuSubmitlog = (data) => post("timu/submitlog", data);
/**
 * 练习记录详情
 * @param {} data 
 * @returns 
 */
const userTrainlogdetail = (data) => post("user/trainlogdetail", data);
/**
 * 刷题结果数据
 * @param {} data 
 * @returns 
 */
const userTrainresult = (data) => post("user/trainresult", data);

/**
 * 真题模考 得到一级分类
 * @param {} data 
 * @returns 
 */
const examGetcate = (data) => post("exam/getcate", data);
/**
 * 真题模考 得到试卷列表
 * @param {} data 
 * @returns 
 */
const examGettestpaperlist = (data) => post("exam/gettestpaperlist", data);
/**
 * 真题模考 得到考试须知
 * @param {} data 
 * @returns 
 */
const examGetxuzhi = (data) => post("exam/getxuzhi", data);
/**
 * 得到试卷中的所有题目
 * @param {} data 
 * @returns 
 */
const examGettimulist = (data) => post("exam/gettimulist", data);
/**
 * 得到试卷中的所有题目 新
 * @param {} data 
 * @returns 
 */
const examGettimulistnew = (data) => post("exam/gettimulistnew", data);
/**
 * 开始考试 记录开始考试时间 或 取出最近未结束的考试开始时间
 * @param {} data 
 * @returns 
 */
const examTimelog = (data) => post("exam/timelog", data);
/**
 * 记录考试日志
 * @param {} data 
 * @returns 
 */
const examSetexamlog = (data) => post("exam/setexamlog", data);
/**
 * 通过考试编号得到考试结果
 * @param {} data 
 * @returns 
 */
const examGetresult = (data) => post("exam/getresult", data);

export default {
    userRegister,
    userLogin,
    userIndex,
    userLogout,
    userResetpwd,
    userParentsauth,
    userStudentauth,
    userTrainwrongloglist,
    userExamwrongloglist,
    userTrainwrongtimu,
    userExamwrongtimu,
    userExamwrongtimunew,
    userTrainlog,
    userExamlog,
    userTrainwrongtimunew,

    indexBaseinfo,
    indexNewcourse,
    indexCatecourse,
    indexGetfooter,
    indexAboutus,
    indexEnvironment,
    indexFengcai,

    courseGetcate,
    courseGetlist,
    courseCoursedetail,
    courseSetstudylog,

    timuGetcate,
    timuGetchildcate,
    timuGetlibrarylist,
    timuGettimulist,
    timuGettimulistnew,
    timuSettrainlog,
    timuSubmitlog,
    userTrainlogdetail,
    userTrainresult,

    examGetcate,
    examGettestpaperlist,
    examGetxuzhi,
    examGettimulist,
    examGettimulistnew,
    examTimelog,
    examSetexamlog,
    examGetresult,






}